import { addProvider } from "../ServiceUtil/providerDescriptors";
import { IProviderDescriptor } from "../ServiceUtil/provider.descriptor.interface";
import { of as observableOf, Observable, BehaviorSubject } from "rxjs";
import { mergeMap, catchError, share } from "rxjs/operators";
import { ConfigDelgate } from "./config.delegate";
import { IClientSpocClients, IConfig, IConfigCategory, IConfigItem, INewConfigItem } from "./config.interface";
import { AuthenticationService } from "../AuthenticationService";
import { IClientResponses } from "../HMFlowService";

export class ConfigService {
    public configData: IConfig = {} as IConfig;
    private configSubject: BehaviorSubject<any> = new BehaviorSubject(null);
    public config: Observable<IConfig> = this.configSubject;

    public configCategoryData: IConfigCategory[] = [];
    private configCategorySubject: BehaviorSubject<any> = new BehaviorSubject(null);
    public configCategories: Observable<IConfigCategory[]> = this.configCategorySubject;

    public hmClientsData: IClientSpocClients[] = [];
    private hmClientsSubject: BehaviorSubject<any> = new BehaviorSubject(null);
    public hmClients: Observable<IClientSpocClients[]> = this.hmClientsSubject;

    private filteredClientsSubject: BehaviorSubject<IClientSpocClients[]> = new BehaviorSubject(null);
    public filteredClients: Observable<IClientSpocClients[]> = this.filteredClientsSubject;

    private filteredActiveClientsSubject: BehaviorSubject<IClientSpocClients[]> = new BehaviorSubject(null);
    public filteredActiveClients: Observable<IClientSpocClients[]> = this.filteredActiveClientsSubject;


    private selectedConfigKey: string = "0";
    public filterClientStatus: boolean = true;

    constructor(private configDelgate: ConfigDelgate,
        private authenticationService: AuthenticationService) {
        this.configSubject = new BehaviorSubject(this.configData);
    }

    public get configCategory(): string {
        return this.selectedConfigKey;
    }

    public setSelectedConfigKey(configKey: string): void {
        this.selectedConfigKey = configKey;
    }

    public getSelectedConfigCategory(): IConfigCategory {
        return this.configCategoryData.find(configCategory => configCategory.categoryKey === this.selectedConfigKey);
    }

    public updateConfigItem(configItem: IConfigItem): Observable<boolean> {
        const response = this.configDelgate.updateConfigItem({ ...configItem, ...this.authenticationService.getBaseRequest });
        return this.processconfigCategories(response);
    }


    public createNewConfigItem(newConfigItem: INewConfigItem): Observable<boolean> {
        const response = this.configDelgate.createConfigItem({ ...newConfigItem, ...this.authenticationService.getBaseRequest });
        return this.processconfigCategories(response);
    }

    public getConfigCategories(): Observable<boolean> {
        var response = this.configDelgate.getConfigCategories();

        return this.processconfigCategories(response);
    }

    public getConfigByOrg(): Observable<boolean> {
        const orgId = this.authenticationService.GetOrgId();
        var config = this.configDelgate.getConfigByOrg(orgId);

        config.subscribe(onConfigurationSuccess.bind(this), onConfigurationFault.bind(this));

        return config.pipe(mergeMap((response: IConfig) => {
            return observableOf(true);

        }),
            catchError(() => observableOf(false)),
            share());


        function onConfigurationSuccess(response: IConfig) {
            if (response) {
                this.configData = response;
                this.configSubject.next(this.configData);
                this.hmClientsData = this.configData.clients;
                this.hmClientsSubject.next(this.hmClientsData);
                // this.hmClientsSubject.next(this.hmClientsData.filter(c=>c.isActive===true));
                this.filteredActiveClientsSubject.next(this.hmClientsData.filter(c => c.isActive === true));
                this.filteredClientsSubject.next(this.hmClientsData.filter(c => c.isActive === true));

                this.getClientsByStatus(this.filterClientStatus)
            }
        }

        function onConfigurationFault(error: any) {
            // ConfigService.logger.error(`getConfig - Error (${JSON.stringify(error)})`);
        }
    }

    public getConfig(): Observable<boolean> {
        var config = this.configDelgate.getConfig();

        config.subscribe(onConfigurationSuccess.bind(this), onConfigurationFault.bind(this));

        return config.pipe(mergeMap((response: IConfig) => {
            return observableOf(true);

        }),
            catchError(() => observableOf(false)),
            share());


        function onConfigurationSuccess(response: IConfig) {
            if (response) {
                this.configData = response;
                this.configSubject.next(this.configData);
            }
        }

        function onConfigurationFault(error: any) {
            // ConfigService.logger.error(`getConfig - Error (${JSON.stringify(error)})`);
        }
    }

    public getClientsByStatus(active: boolean) {
        this.filterClientStatus = active;
        let data = this.hmClientsData;
        data = this.hmClientsData.filter(x => x.isActive === active);
        this.filteredClientsSubject.next(data);
    }

    private processconfigCategories(configCategories: Observable<IConfigCategory[]>, update: boolean = true): Observable<boolean> {
        configCategories.subscribe(onConfigurationSuccess.bind(this), onConfigurationFault.bind(this));

        return configCategories.pipe(mergeMap((response: IConfigCategory[]) => {
            return observableOf(true);

        }),
            catchError(() => observableOf(false)),
            share());


        function onConfigurationSuccess(response: IConfigCategory[]) {
            if (response) {
                this.configCategoryData = response;
                this.configCategorySubject.next(this.configCategoryData);
            }
        }

        function onConfigurationFault(error: any) {
            //  ConfigService.logger.error(`getConfigCategories - Error (${JSON.stringify(error)})`);
        }
    }
}